import { Injectable } from '@angular/core';
import { RequestResponse } from '../intefaces/requestResponse';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { ArrangerDetails } from '../intefaces/arranger-details.interface';
import { InvoiceData } from '../intefaces/invoice-data.interface';
import { ContractData } from '../intefaces/contract-data.interface';


@Injectable({
    providedIn: 'root'
})
export class AdminService extends BaseService {

    constructor(protected http: HttpClient) {
        super();
    }


    public blockUser(id: number) {
        return this.http.post<RequestResponse>(this.getUrl('blockUser'), { id: id });
    }

    public unblockUser(id: number) {
        return this.http.post<RequestResponse>(this.getUrl('unblockUser'), { id: id });
    }

    public blockSellingNotes(id: number) {
        return this.http.post<RequestResponse>(this.getUrl('blockSellingNotes'), { id: id });
    }

    public addToArrangers(id: number) {
        return this.http.post<RequestResponse>(this.getUrl('addToArrangers'), { id: id });
    }

    public removeFromArrangers(id: number) {
        return this.http.post<RequestResponse>(this.getUrl('removeFromArrangers'), { id: id });
    }

    public addToAdministrators(id: number) {
        return this.http.post<RequestResponse>(this.getUrl('addToAdministrators'), { id: id });
    }

    public removeFromAdministrators(id: number) {
        return this.http.post<RequestResponse>(this.getUrl('removeFromAdministrators'), { id: id });
    }

    public getArrangerDetailsByAdmin(id: number) {
        return this.http.post<RequestResponse>(this.getUrl('getArrangerDetailsByAdmin'), { id: id });
    }

    public getArrangerCommission(id: number) {
        return this.http.post<RequestResponse>(this.getUrl('getArrangerCommission'), { id: id });
    }

    public updateUserDetailsByAdmin(data: any) {
        return this.http.post<RequestResponse>(this.getUrl('updateUserDetailsByAdmin'), data);
    }

    public updateArrangerDetails(arrangerDetails: ArrangerDetails) {
        return this.http.post<RequestResponse>(this.getUrl('updateArrangerDetailsByAdmin'), arrangerDetails);
    }

    public updateArrangerCommission(arrangerDetails: ArrangerDetails) {
        return this.http.post<RequestResponse>(this.getUrl('updateArrangerCommissionByAdmin'), arrangerDetails);
    }

    public updateShortDescByAdmin(arrangerDetails: ArrangerDetails) {
        return this.http.post<RequestResponse>(this.getUrl('updateShortDescByAdmin'), arrangerDetails);
    }

    public updateFullDescByAdmin(arrangerDetails: ArrangerDetails) {
        return this.http.post<RequestResponse>(this.getUrl('updateFullDescByAdmin'), arrangerDetails);
    }

    public getUserWithDetails(id: number) {
        return this.http.post<RequestResponse>(this.getUrl('getUserWithDetails'), { id: id });
    }

    public getUserSearch(params: any, page: number, rows: number) {
        let data = { params: params, page: page, rows: rows };
        return this.http.post<RequestResponse>(this.getUrl('getUserSearch'), data);
    }

    public getUserAuditHistory(id: number, date_start: Date, date_end: Date, selectedFilters: any, page: number, rows: number) {
        let data = { id: id, date_start: date_start, date_end: date_end, filters: selectedFilters, page: page, rows: rows };
        return this.http.post<RequestResponse>(this.getUrl('getUserAuditHistory'), data);
    }

    public downloadUsersExcel(): Observable<Blob> {
        return this.http.get(this.getUrl('exportUsersToExcel'), { responseType: 'blob' });
    }

    public downloadInvoices(from: string, to: string): Observable<any> {
        return this.http.get(this.getUrl('downloadInvoices'), { params: { from: from, to: to }, responseType: 'blob' });
    }

    public downloadTestInvoice(): Observable<Blob> {
        return this.http.get(this.getUrl('generateTestInvoice'), { responseType: 'blob' });
    }

    public getInvoiceData() {
        return this.http.get<RequestResponse>(this.getUrl('getInvoiceData'));
    }

    public updateInvoiceData(invoiceData: InvoiceData) {
        return this.http.post<RequestResponse>(this.getUrl('updateInvoiceData'), { invoice_data: invoiceData });
    }

    public updateContractData(contractData: ContractData) {
        return this.http.post<RequestResponse>(this.getUrl('updateContractData'), { contract_data: contractData });
    }

    public getContractData() {
        return this.http.get<RequestResponse>(this.getUrl('getContractData'));
    }

    public downloadTestContract(): Observable<Blob> {
        return this.http.get(this.getUrl('generateTestContract'), { responseType: 'blob' });
    }

    public getContractEmail() {
        return this.http.get<RequestResponse>(this.getUrl('getContractEmail'));
    }

    public sendTestContractEmail(email: string) {
        return this.http.post<RequestResponse>(this.getUrl('sendTestContractEmail'), { email: email });
    }

    public getArrangerContractSignDate(id: number) {
        return this.http.post<RequestResponse>(this.getUrl('getArrangerContractSignDate'), { id: id });
    }

    public updateArrangerContractSignDate(user_id: number, contract_date_signment: string) {
        return this.http.post<RequestResponse>(this.getUrl('updateArrangerContractSignDate'), { user_id: user_id, contract_date_signment: contract_date_signment });
    }

}
